import { ACCESS_PROFILE, RDC_USER } from "./roles";
import { UserSource } from "./source";
import { BaseProfile, IProfile } from "./profiles";
import { getUser } from "./index";

interface RDCRole {
	UserRoleEn: string;
	UserRoleAr: string;
	Identity: number;
}

interface RDCUserType {
	UserTypeEn: string;
	UserTypeAr: string;
	Identity: number;
}

export interface IRDCProfile extends IProfile {
	FirstName: string;
	LastName: string;
	UserName: string;
	MobileNumber?: string;
	UserTypes: RDCUserType[];
	UserRoles: RDCRole[];
	IsOnlineUserRole: boolean;
	UserType: number;
	Identity: number;
}

export class RDCProfile extends BaseProfile implements IRDCProfile {
	FirstName: string;
	LastName: string;
	UserName: string;
	MobileNumber?: string;
	UserTypes: RDCUserType[];
	UserRoles: RDCRole[];
	IsOnlineUserRole: boolean;
	UserType: number;
	Identity: number;

	constructor( profile: IRDCProfile ) {
		super( UserSource.RDC, profile.Identity );
		this.refreshRoles();
		this.FirstName = profile.FirstName;
		this.LastName = profile.LastName;
		this.UserName = profile.UserName;
		this.MobileNumber = profile.MobileNumber ? profile.MobileNumber.replace( /[^\d]/g, "" ) : undefined;
		this.UserTypes = profile.UserTypes;
		this.UserRoles = profile.UserRoles;
		this.IsOnlineUserRole = profile.IsOnlineUserRole;
		this.UserType = profile.UserType;
		this.Identity = profile.Identity;
	}

	static buildProfile( profile: IRDCProfile ): RDCProfile {
		const p = new RDCProfile( profile );
		return p;
	}

	static getProfile(): RDCProfile | undefined {
		const u = getUser();
		if ( u )
			return u.getProfile( UserSource.RDC ) as RDCProfile;
		return undefined;
	}

	refreshRoles() {
		super.refreshRoles();
		if ( !this.hasRole( RDC_USER ) ) this.addRole( RDC_USER );
		if ( !this.hasRole( ACCESS_PROFILE ) ) this.addRole( ACCESS_PROFILE );
	}

	getUserType() {
		return this.UserTypes[ 0 ].Identity;
	}

	getUserRole() {
		return this.UserRoles[ 0 ].Identity;
	}
}
